import api from './api';

class AuthService {
    // Check email and send OTP for signup
    async checkEmail(email) {
        try {
            const response = await api.post('/auth/check-email', { email });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Verify OTP for signup
    async verifySignupOTP(email, otp) {
        try {
            const response = await api.post('/auth/verify-signup-otp', { email, otp });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Sign up new customer (after OTP verification)
    async signup(userData) {
        try {
            const response = await api.post('/auth/signup', userData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Login user (Customer or Admin)
    async login(credentials) {
        try {
            const response = await api.post('/auth/login', credentials);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Forgot password - send OTP
    async forgotPassword(email) {
        try {
            const response = await api.post('/auth/forgot-password', { email });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Verify OTP
    async verifyOTP(email, otp) {
        try {
            const response = await api.post('/auth/verify-otp', { email, otp });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Change password with OTP
    async changePassword(email, otp, newPassword) {
        try {
            const response = await api.post('/auth/change-password', { 
                email, 
                otp, 
                newPassword 
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Logout
    async logout() {
        try {
            const response = await api.post('/auth/logout');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Verify token and get user info
    async verifyToken() {
        try {
            const response = await api.get('/auth/verify');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new AuthService();